
import { useState, useEffect} from "react";

import Config from "../Config";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


import GroupNew from "../modules/kids/GroupNew";

function InputComboGrupa(props)
{

    var cData = Config.getFromBuffer(Config.cache_grups,3600, props.userData );
   
    var defShowAll = 0;
    if(props.all != undefined && props.all == 1 ) defShowAll = 1;
    const [showAll, setShowAll] = useState(defShowAll);

    const [gr, setGr] = useState(cData);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const [forwardList, setForwardList] = useState(0); // to komponentu może być podpięta akcja fetchTab={}, lista z grupami zostanie przekazana wyżej..

    

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            
        };
       

        fetch( Config.url + '/rest_v1_kids,gr', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);                                                                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

   

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

 


        setVal(v);

        var correct = true;

        if(req == '1' &&  v=='_x_' ) correct = false;         

        if(v == '_y_del')
        {
            setView({
                v: 'new',
                id: -1
            });
            return;
        }
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'combo');           
        }else
        {
            console.log('No support for valChange');
        }    


        if(props.nChange != null && props.nChange != undefined)
        {
            var nName = "?";

            for(var k=0; k< gr.length; k++)
            {
                if(gr[k].v == v){
                    nName = gr[k].title;
                }
            }


            props.nChange(nName);
        }

    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val == '_x_') correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {


   

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })



    const onBack = (id) => {                 
        
        setVal(id);
        setGr(null);
       
  
        
        setView({
            v: 'list',
            id: -1
        });
    }




    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setGr(null);    
        }


    var dlg = null;
    
   
    if(view.v == 'new')
    {
         dlg =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Nowa grupa
                    </div>


                    <div className="dlg_content_x">


                            <GroupNew  userData={props.userData} mainView={props.mainView} onBack={onBack} />      

                    </div>

                
            </div>
    );
    }
    

    
    if( gr == null ||  gr.length == 0 )
    {
        getGr();
        
        return <fieldset>
                    <select  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cn} >
                            <option value="">...</option>
                            <option value="_y_">nowa (+)</option>
                    </select>
                    {imgx}
             <br/>
             <span className="form_err">  &nbsp; </span>   
             {dlg}          
           </fieldset>                     
        
    }


    

    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    var cnX = cn;
    if(val.length < 1 && cnX == 'corrent')
    {
            cnX = '';
    }

 
    var readyGR = new Array();


    if(showAll == 1)
    {
        readyGR.push({
            v: "_x_",
            title: "- - - ",
        });

        readyGR.push({
            v: "_y_",
            title: "Wszystkie grupy",
        });

        for(var k=0; k< gr.length; k++)
        {
            if( gr[k].v == "_x_") continue;            
            readyGR.push(
                gr[k]
            );
        }

    }else
    {
        readyGR = gr;
    }



    if(forwardList == 0 && gr != null && gr.length > 0 && props.fetchTab != null )
    {
        setForwardList(1);
        props.fetchTab(gr);
    }
 

    return <fieldset>
          
            <select   value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} >

               

                {
                    readyGR.map( (item, ix) => {
                        return <option value={item.v} key={item.v}>{item.title}</option>
                    } )
                }
              
            </select>

             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>             
             {dlg}
           </fieldset>
}


export default InputComboGrupa;

